import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { invoiceQueryKeys } from "../api/queryKeys";

import { instance } from "@/lib/axios/instance";
import { ChannelType } from "@/types/response/ChannelType";

type UseChannelParams = {
  channelId: string;
};

/**
 * Fetches a single channel by ID.
 * Used to get channel details like name and metadata.
 */
export function useChannel(params: UseChannelParams) {
  return useQuery<ChannelType, AxiosError>({
    queryKey: [...invoiceQueryKeys.channels.all(), "detail", params.channelId],
    queryFn: () =>
      instance
        .get<ChannelType>(`/api/v2/Channels/${params.channelId}`)
        .then((res) => res.data),
    enabled: !!params.channelId,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
